import React, { useState } from "react";
import {  Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";
import { deepCopy } from "../../Shared/Utility/DeepCopy";
import { CcAssessmentPathwayEnrollmentCertificate } from "../Models/CcAssessmentPathwayEnrollment";
import SelectCertificationRow from "./SelectCertificationRow";

interface IProps {
    isSectionOpen: boolean;
    onSave?: () => void;
    onUpdate?: () => void;
    onOpen?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    onContinue: () => void;
    certificates: Array<CcAssessmentPathwayEnrollmentCertificate>;
    updateCertificates: (certificates: Array<CcAssessmentPathwayEnrollmentCertificate>) => void;
}

export default function SelectCertifications(props: IProps){
    const [errorMessages, setErrorMessages] = useState([]);
    
    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (validateSelection()) {
            props.onContinue();
        }
    }

    const validateSelection = () => {
        console.log(props.certificates);
        let newErrorMessages = [];
        var unselectedCerts = props.certificates.filter(_ => _.isEnrolled && (_.ccAssessmentType === null));
        if (unselectedCerts.length > 0)
        {
            newErrorMessages.push("You must select a pathway for all enrolled certifications");
        }
        
        setErrorMessages(newErrorMessages);
        return newErrorMessages.length === 0;
    }

    const onUpdateEnrollmentCert = (certificate: CcAssessmentPathwayEnrollmentCertificate)=> {
        // Get Certificate from props and update, then send the collection back to parent
        var updated = deepCopy(props.certificates);
        var index = updated.findIndex((_: CcAssessmentPathwayEnrollmentCertificate) => _.certificateId == certificate.certificateId);
        updated[index] = certificate;
        props.updateCertificates(updated);

    }
    
    if (props.isLoading) return <AbpnSpinner></AbpnSpinner>
    return (
        <React.Fragment>
            { !(props.disabled) &&
                    <Card className="mb-3" border="pp-secondary-grey">
                        <Card.Body>
                            <Card.Title className="font-weight-bolder">
                            CERTIFICATIONS
                            </Card.Title>
                                <Row className="mt-3">
                                    <Col xs={12} md={12} lg={12} xl={12}>
                                        <Form noValidate onSubmit={(e) => onSubmit(e)}>
                                            <Form.Group>
                                                <Col>
                                                    <p className="font-weight-bold">Please review your certifications eligible for Continuing Certification</p>
                                                    {props.certificates.map((certificate: CcAssessmentPathwayEnrollmentCertificate) => 
                                                            <SelectCertificationRow
                                                                key={certificate.certificateId} 
                                                                certificate={certificate}
                                                                updateEnrollmentCert={onUpdateEnrollmentCert} />
                                                        )}
                                                </Col>
                                            </Form.Group>
                                                {errorMessages.length > 0 &&
                                                <Alert className="pp-font-size-smaller" variant="pp-alert-danger">
                                                    {errorMessages.map(errorMessage => <p>{errorMessage}</p>)}
                                                </Alert>
                                                }
                                                    {props.isLoading ? <AbpnSpinner /> : 
                                                        <Row>
                                                            <Col xs={12} lg={6}>
                                                                &nbsp;
                                                            </Col>
                                                            <Col xs={12} lg={6}>
                                                                
                                                                <Button type="submit" variant="pp-primary">Continue</Button>
                                                            </Col>
                                                        </Row>

                                                        }
                                        </Form>
                                    </Col>
                                </Row>
                        </Card.Body>
                    </Card>        
            }
        </React.Fragment>
    )
}